/**
 * Care Context
 *
 * Provides care-related state and data to the app.
 * Currently a placeholder - will be expanded with actual care data.
 */

import { createContext, useContext, ReactNode } from "react";

type CareContextValue = {
  // Placeholder for care-related state
};

const CareContext = createContext<CareContextValue | undefined>(undefined);

export type CareProviderProps = {
  children: ReactNode;
};

export function CareProvider({ children }: CareProviderProps) {
  return (
    <CareContext.Provider value={{}}>
      {children}
    </CareContext.Provider>
  );
}

export function useCare() {
  const context = useContext(CareContext);
  if (context === undefined) {
    throw new Error("useCare must be used within a CareProvider");
  }
  return context;
}
